<template>
  <ModalBase
    @closed="emit('closed')"
    :closeBtn="true"
    :full="true"
    bodyClass="modal-gallery"
  >
    <div class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(s, i) in data" :key="i">
          <img :src="s" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
  </ModalBase>
</template>

<script setup>
const { setIndex } = useModal();
const emit = defineEmits(["closed"]);
const props = defineProps(["data", "current"]);
const sw = ref();

onMounted(async () => {
  await useSwiper();
  sw.value = new Swiper(".swiper", {
    loop: true,
    initialSlide: props.current || 0,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: false,
    },
  });
  sw.value.on("transitionEnd", () => setIndex(sw.value.realIndex));
});
onUnmounted(() => sw.value.destroy());
</script>
